import { LS_REDIRECT_URI } from 'core/constants'
import { SIGN_IN, SIGN_UP, TO_FIREBASE } from 'core/modules/router'
import { Location } from 'history'
import { useEffect, useMemo, useRef } from 'react'
import { useLocation } from 'react-router-dom'

const IGNORED_ROUTES = [TO_FIREBASE[SIGN_UP], TO_FIREBASE[SIGN_IN]]

/**
 * Persists the previous location on Local Storage.
 * Trick to obtain the previous location, based on: https://usehooks.com/usePrevious/
 */
export const useStorePreviousLocation = () => {
  const { pathname } = useLocation<Location>()

  const ref = useRef<string>()

  useEffect(() => {
    ref.current = pathname
  }, [pathname])

  if (ref.current && !IGNORED_ROUTES.includes(ref.current)) {
    localStorage.setItem(LS_REDIRECT_URI, ref.current)
  }
}

export function useRootScroollableDiv() {
  return useMemo(
    () =>
      [
        document.getElementById('scrollable-content') as HTMLDivElement,
        document.getElementById('root')! as HTMLDivElement,
        document.body,
      ].filter(Boolean),
    []
  )
}

export function useScrollToTop() {
  const root = useRootScroollableDiv()
  return () => {
    setTimeout(() => {
      for (let d of root) d.scrollTo({ behavior: 'smooth', left: 0, top: 0 })
    }, 100)
  }
}

export function useScrollWhenEffect(...deps: any[]) {
  const scroll = useScrollToTop()
  useEffect(() => {
    scroll()
  }, deps)
}
